import { render } from "./SectionActivityLog.vue?vue&type=template&id=5448db4b&scoped=true"
import script from "./SectionActivityLog.vue?vue&type=script&lang=js"
export * from "./SectionActivityLog.vue?vue&type=script&lang=js"

import "./SectionActivityLog.vue?vue&type=style&index=0&id=5448db4b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5448db4b"]])

export default __exports__